import { useEffect, useRef, useState } from "react";
import { IoCheckmarkCircle } from "react-icons/io5";

const EmployeePopup = (props) => {
  const popupref = useRef(null);
  const [search, setsearch] = useState("");
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        props.activateoutsidecontainerclick();
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupref]);

  const handlemessageChange = (event) => {
    setsearch(event.target.value);
  };
  return (
    props.visible && (
      <div
        ref={popupref}
        className={`w-[250px] ${
          props.multi == true ? "max-h-[215px]" : "max-h-[1855px]"
        }  bg-themelightblack border border-bordercolor rounded-md  gk-scr p-[10px] position absolute top-[50px] z-10  left-[0px]  self-start`}
        style={props.style}
      >
        {props.multi == true && (
          <div
            onClick={() => {
              props.data.find((x) => x.selected == false) == undefined
                ? props.bulkaction(false)
                : props.bulkaction(true);
            }}
            className={`flex flex-row items-center justify-end  w-full py-[5px] cursor-pointer text-white   hover:underline hover:text-white/20  hover:rounded-xl `}
          >
            <p className=" PoppinsRegular text-sm ml-[10px]">
              {props.data.find((x) => x.selected == false) == undefined
                ? "Deselect All"
                : "Select All"}
            </p>
          </div>
        )}
        <input
          type="text"
          value={search}
          placeholder="Search"
          onChange={handlemessageChange}
          className="input px-4 text-black text-sm  PoppinsRegular w-full py-2 rounded-xl border border-bordercolor items-center flex mb-[10px] bg-white"
        />
        <div className="w-full overflow-y-scroll max-h-[120px]">
          {props.data.map((item, index) =>
            item.firstname.toLowerCase().includes(search.toLowerCase()) ||
            item.lastname.toLowerCase().includes(search.toLowerCase())
              ? !item?.disabled && (
                  <div
                    key={index.toString()}
                    onClick={() => {
                      props.onClick(item, index);
                    }}
                    className={`flex flex-row items-center  w-full py-[5px] cursor-pointer hover:bg-themeblue text-white  hover:rounded-xl hover:px-[10px]`}
                  >
                    {/* // className={`flex flex - row items - center justify - between w - full py - [5px] cursor-pointer hover:bg-themeColor hover:text-white text-textcolor hover:rounded-xl hover:px-[10px]`}> */}
                    <img loading="lazy"
                      src={item.profilepicture}
                      className="w-[25px] h-[25px] rounded-full object-cover"
                    />
                    <p className="  PoppinsRegular text-sm ml-[10px]">
                      {item.firstname + " " + item.lastname}
                    </p>
                    {item.selected && (
                      <IoCheckmarkCircle className="   w-[20px] h-[20px] text-themegreen" />
                    )}
                  </div>
                )
              : null
          )}
        </div>
      </div>
    )
  );
};

export default EmployeePopup;
